import React from 'react';

import { ReportTemplate } from 'api/endPoints/GetReportTemplateList';

import { CreateReportCard } from 'components/common/CreateReportCard/CreateReportCard';
import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';

import { SelectedTemplateWithAction } from 'components/widgets/ReportsHome/ReportsTemplates/ReportsTemplates';
import { BuiltByBadge } from 'components/widgets/ReportsHome/ReportsTemplates/components/BuiltByBadge/BuiltByBadge';
import classes from 'components/widgets/ReportsHome/ReportsTemplates/components/InitialTemplateCards/components/TemplateSection/TemplateSection.module.scss';

interface Props {
    templates: ReportTemplate[];
    title: string;
    setSelectedTemplate: (templateWithAction: SelectedTemplateWithAction | null) => void;
}

export const TemplateSection = ({ templates, setSelectedTemplate, title }: Props) => {
    return (
        <div className={classes.templatesSection}>
            <div className={classes.subTitle}>{title}</div>
            <div className={classes.templatesWrapper}>
                {templates.map((template) => (
                    <CreateReportCard
                        key={template.id}
                        title={template.name}
                        titleIcon={<BuiltByBadge user={template.createdBy} showFullName={false} />}
                        details={template.description}
                        actionButtonIcon={<MuiIcon icon={'add'} color={'var(--button-primary-fg)'} />}
                        actionButtonChildren={'Create report'}
                        onClick={() => setSelectedTemplate({ templateId: template.id, action: 'createReport' })}
                    />
                ))}
            </div>
        </div>
    );
};
